import { useState } from "react";
import {
  Box,
  Flex,
  Image,
  Text,
  SimpleGrid,
  GridItem,
  Heading,
  Icon,
  Accordion,
} from "@chakra-ui/react";
import { TiArrowRight } from "react-icons/ti";
import { HiPlus, HiMinus } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

import { Hero } from "../components/Hero";
import { InfinityBanner } from "../components/InfinityBanner";
import { Testimonials } from "../components/Testimonials";
import { Footer } from "../components/Footer";

import { faqs } from "../core/constants";

// import WavyBg from "../assets/images/wavyBg.png";
import Notification from "../assets/images/notification.png";

export const Home = () => {
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState(["a"]);

  const handleValueChange = ({ value }: any) => {
    setActiveItem(value.length ? [value[value.length - 1]] : []);
  };

  return (
    <Box>
      <Hero />

      <InfinityBanner />

      <Testimonials />

      <InfinityBanner />

      <Box
        h="auto"
        px={{ base: "16px", lg: "100px" }}
        pt="64px"
        pb="87px"
        backgroundSize={"cover"}
        backgroundPosition={"center"}
        bgRepeat={"no-repeat"}
        // backgroundImage={`url(${WavyBg})`}
        // zIndex={-1}
        // bgColor="rgba(209,218,228,0.5)"
        maxW={{ base: "100%", "2xl": "1500px" }}
        mx="auto"
      >
        <SimpleGrid
          columns={{ base: 1, lg: 2 }}
          gap={{ base: "45px", lg: "121px" }}
          h={"100%"}
        >
          <GridItem
            bg="rgba(217, 237, 140, 0.3)"
            borderRadius={"40px"}
            borderWidth={"1px"}
            borderColor={"#E3E8EE1A"}
            py="40px"
            px="20px"
          >
            <Flex
              // maxW={"342px"}
              flexDir={"column"}
              h={"100%"}
              align={"center"}
              justify={"center"}
            >
              <Heading
                fontSize={{ base: "36px", lg: "88px" }}
                color={"#19202D"}
                fontWeight={400}
                lineHeight={"100%"}
              >
                We Mean
              </Heading>
              <Heading
                fontSize={{ base: "36px", lg: "88px" }}
                color={"#19202D"}
                fontWeight={700}
                lineHeight={"100%"}
              >
                Business!
              </Heading>

              <Image
                src={Notification}
                h="88px"
                w={"100%"}
                objectFit={"contain"}
                my="40px"
              />

              <Flex
                py="20px"
                px="24px"
                bg="#19202D"
                borderRadius={"30px"}
                gap={"10px"}
                align={"center"}
                cursor={"pointer"}
                onClick={() =>
                  window.open(
                    "https://calendly.com/book-d/book-d-set-up",
                    "_blank",
                  )
                }
              >
                <Heading
                  color={"#fff"}
                  fontSize={"22px"}
                  fontFamily={"LeagueSpartan"}
                  lineHeight={"100%"}
                >
                  SCHEDULE A DEMO
                </Heading>

                <Icon size={"xl"} color={"#FFF"}>
                  <TiArrowRight />
                </Icon>
              </Flex>

              <Flex
                pt="20px"
                pb="16px"
                px="24px"
                bg="#FF8E3C"
                borderRadius={"30px"}
                gap={"10px"}
                align={"center"}
                cursor={"pointer"}
                mt="16px"
                _hover={{ bg: "#E07A2E" }}
                transition="background 0.2s"
                onClick={() => navigate("/pricing")}
              >
                <Heading
                  color={"#fff"}
                  fontSize={"22px"}
                  fontFamily={"LeagueSpartan"}
                  lineHeight={"100%"}
                >
                  VIEW PRICING
                </Heading>

                <Icon size={"xl"} color={"#FFF"}>
                  <TiArrowRight />
                </Icon>
              </Flex>
            </Flex>
          </GridItem>

          <GridItem alignContent={"center"}>
            <Heading
              fontSize={"32px"}
              fontWeight={400}
              fontFamily={"LeagueSpartan"}
              color={"#19202D"}
              mb="20px"
              textAlign={{ base: "center", lg: "left" }}
            >
              Got Questions?
            </Heading>

            <Accordion.Root
              value={activeItem}
              onValueChange={handleValueChange}
              collapsible
              defaultValue={["a"]}
              borderWidth={"1px"}
              borderColor="#E5E9EC"
              borderRadius={"20px"}
            >
              {faqs.map((item, index) => {
                const isLast = index === faqs.length - 1;
                const isFirst = index === 0;
                const isActive = activeItem.includes(item.id);

                return (
                  <Accordion.Item
                    key={index}
                    value={item.id}
                    p="20px"
                    borderTopRightRadius={isFirst ? "20px" : 0}
                    borderTopLeftRadius={isFirst ? "20px" : 0}
                    borderBottomRightRadius={isLast ? "20px" : 0}
                    borderBottomLeftRadius={isLast ? "20px" : 0}
                    bg={isActive ? "rgba(217, 237, 140, 0.6)" : "transparent"}
                    borderBottomWidth={isLast ? 0 : 1}
                    borderColor="#E5E9EC"
                  >
                    <Accordion.ItemTrigger>
                      <Text
                        flex="1"
                        color={"#000"}
                        fontSize={"24px"}
                        fontFamily={"LeagueSpartan"}
                        fontWeight={400}
                      >
                        {item.title}
                      </Text>

                      <Icon size={"lg"} color="#000">
                        {isActive ? <HiMinus /> : <HiPlus />}
                      </Icon>
                    </Accordion.ItemTrigger>

                    <Accordion.ItemContent>
                      <Accordion.ItemBody color={"#19202D"} fontSize={"16px"}>
                        {item.body}
                      </Accordion.ItemBody>
                    </Accordion.ItemContent>
                  </Accordion.Item>
                );
              })}
            </Accordion.Root>
          </GridItem>
        </SimpleGrid>
      </Box>

      <Footer appType="stylist" />
    </Box>
  );
};
